import React, { useContext } from "react";
import { Button as SpendeskButton } from "@dev-spendesk/grapes";
import { ENDPOINT } from "./config";
import { AuthenticatedApiContext } from "../context/AuthenticatedApiContext";

export default function LoginButton({ user, text, processId }) {
  const { get, post } = useContext(AuthenticatedApiContext);

  async function getUserOrAoCredentials(user, processId) {
    if (user && user.email) {
      return { email: user.email, password: user.password };
    }
    if (processId) {
      const users = await get(`${ENDPOINT}/users/${processId}`);
      const accountOwner =
        users.length && users.find((user) => user.role === "Account owner");
      return { email: accountOwner.email, password: accountOwner.password };
    }
  }

  async function login() {
    const userCredentials = await getUserOrAoCredentials(user, processId);
    window.open(
      `https://api.demo.spendesk.com/authv2/demo/login/cookie?auth_type=password&username=${encodeURIComponent(
        userCredentials.email
      )}&password=${encodeURIComponent(userCredentials.password)}`,
      "_blank"
    );
  }

  const isLoginAvailable = (user && user.email) || processId;

  return (
    <SpendeskButton
      fit="content"
      iconPosition="left"
      iconName="external"
      text={text}
      type="button"
      variant="contrasted"
      onClick={login}
      isDisabled={!isLoginAvailable}
      className="flex items-center gap-2 text-sm font-medium text-violet-600 bg-violet-50 border border-violet-200 rounded-lg hover:bg-violet-100 hover:border-violet-300 transition-all"
    />
  );
}
